import React from 'react';
import PropTypes from 'prop-types';

import {Box, Divider, Stack} from 'views/components';
import {Tab, TabContext, TabList, TabPanel} from 'views/components';
import {translate} from 'views/module';

import LoomCaregiverHeader from './header/LoomCaregiverHeader';
import LoomCaregiverProfile from './profile/LoomCaregiverProfile';
import LoomCaregiverInvitations from './invitations/LoomCaregiverInvitations';
import LoomCaregiverSchedule from './schedule/LoomCaregiverSchedule';
import LoomCaregiverClients from './clients/LoomCaregiverClients';
import LoomCaregiverWorkflows from './workflows/LoomCaregiverWorkflows';
import LoomCaregiverCorrespondance from './correspondance/LoomCaregiverCorrespondance';
import Interviews from 'views/scenes/caregiver/detail/caregiver_scenes/caregiver_feed/interviews/Interviews';

export const LOOM_CAREGIVER_FEED_TABS = [
  'PROFILE',
  'WORKFLOWS',
  'INVITATIONS',
  'CORRESPONDANCE',
  'INTERVIEWS',
  'SCHEDULING',
  'CLIENTS',
];

// The feed of a Loom caregiver. It follows the Loom lead feed: only the tabs Loom can feed, and
// every tab is read-only except Cancel on a waiting invitation.
const LoomCaregiverFeed = (props) => {
  const {
    caregiverId,
    caregiver,
    feedTab,
    setFeedTab,
    refresh,
    setRefresh,
  } = props;


  const handleChange = (event, newValue) => {
    setFeedTab(newValue);
  };

  return (
    <Stack spacing={2} divider={<Divider />}>
      <LoomCaregiverHeader
        caregiver={caregiver}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <Box
        sx={{
          boxSizing: 'border-box',
          width: '100%',
          backgroundColor: '#FFFFFF',
          border: '1px solid #E8E4DE',
          borderRadius: '12px',
          overflow: 'hidden',
        }}
      >
        <TabContext
          value={feedTab}
        >
          <TabList
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {
              LOOM_CAREGIVER_FEED_TABS.map((tab) => (
                <Tab
                  key={tab}
                  label={translate(`caregiver.LoomCaregiverDetail.Tabs.${tab}`)}
                  value={tab}
                />
              ))
            }
          </TabList>
          <TabPanel
            value={'PROFILE'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <LoomCaregiverProfile
              caregiver={caregiver}
            />
          </TabPanel>
          <TabPanel
            value={'WORKFLOWS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <LoomCaregiverWorkflows
              caregiverId={caregiverId}
              refresh={refresh}
            />
          </TabPanel>
          <TabPanel
            value={'INVITATIONS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <LoomCaregiverInvitations
              caregiverId={caregiverId}
              caregiverName={caregiver.caregiverDetail.caregiverName}
              refresh={refresh}
            />
          </TabPanel>
          <TabPanel
            value={'CORRESPONDANCE'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <LoomCaregiverCorrespondance
              caregiverId={caregiverId}
              refresh={refresh}
            />
          </TabPanel>
          <TabPanel
            value={'INTERVIEWS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Interviews
              caregiverInterviews={caregiver.caregiverInterviews.list}
            />
          </TabPanel>
          <TabPanel
            value={'SCHEDULING'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <LoomCaregiverSchedule
              caregiverRn={caregiver.caregiverRn}
              refresh={refresh}
            />
          </TabPanel>
          <TabPanel
            value={'CLIENTS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <LoomCaregiverClients
              clientAssignments={caregiver.clientAssignments}
            />
          </TabPanel>
        </TabContext>
      </Box>
    </Stack>
  );
};
LoomCaregiverFeed.propTypes = {
  caregiverId: PropTypes.string.isRequired,
  caregiver: PropTypes.object.isRequired,
  feedTab: PropTypes.string.isRequired,
  setFeedTab: PropTypes.func.isRequired,
  refresh: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(LoomCaregiverFeed);
